import { Channels } from 'generated-graphql/types';
import { CampaignCreationCSVColumns } from 'modules/campaign-creation/components/CampaignCreationCSVUpload';

type CheckChannelCSVIsDisabledProps = {
  channel: Channels;
  csvColumns: CampaignCreationCSVColumns | null;
};

export const checkChannelCSVIsDisabled = ({
  channel,
  csvColumns
}: CheckChannelCSVIsDisabledProps): boolean => {
  if (!csvColumns) {
    return false;
  }

  if (channel === Channels.Whatsapp) {
    return !csvColumns?.phoneNumber || !csvColumns?.phoneNumber?.length;
  }
  if (channel === Channels.Sms) {
    return !csvColumns?.phoneNumber || !csvColumns?.phoneNumber?.length;
  }
  if (channel === Channels.Email) {
    return !csvColumns?.email || !csvColumns?.email?.length;
  }
  return false;
};
